<div class="filter_action_btns">
    <div class="search_bar">
        <div class="search_container">
            <input
                type="text"
                name="search_table"
                placeholder="Search"
                [(ngModel)]="filterValue"
                (ngModelChange)="onInputChange()"
            />
            <img src="assets/icons/search_icon.svg" class="search_icon">
        </div>
    </div>
</div>
